/* Native sources handle unsupported formats. Retry MP4 once on playback failure. */
(() => {
  if (window.kindraVideoFallback) return;
  window.kindraVideoFallback = true;
  const prepare = root => root.querySelectorAll('video[data-kindra-video]').forEach(video => {
    if (video.dataset.fallbackBound) return;
    video.dataset.fallbackBound = 'true';
    let requested = false;
    video.addEventListener('play', () => { requested = true; });
    const fallback = () => {
      const url = video.dataset.mp4Backup;
      if (!url || video.dataset.fallbackUsed || video.currentSrc === new URL(url, document.baseURI).href) return;
      video.dataset.fallbackUsed = 'true';
      const resume = requested || video.closest('video-media')?.hasAttribute('autoplay');
      video.src = url;
      video.load();
      if (resume && video.getClientRects().length) video.play().catch(() => { video.controls = true; });
    };
    video.addEventListener('error', fallback);
    // The final source error also covers failure before a video-level error is dispatched.
    video.querySelector('source:last-of-type')?.addEventListener('error', fallback);
    if (video.error) fallback();
  });
  prepare(document);
  document.addEventListener('shopify:section:load', event => prepare(event.target));
})();
